import type { CSSProperties } from 'react';
import type { ModelKind } from '@/types';

/** True for models that return typed choices rather than text (called via POST /decisions). */
export function isDecisionsModel(m: { kind?: ModelKind | null }): boolean {
  return m.kind === 'Decisions';
}

/**
 * Marks a Decisions model wherever a model is listed, so nobody mistakes it for a chat model.
 * Deliberately not a StatusPill: it describes what the model is, not a state it's in.
 */
export function DecisionsBadge({ style }: { style?: CSSProperties }) {
  return (
    <span
      className="pill pill-decisions"
      style={{ fontSize: '.7rem', ...style }}
      title="Returns typed choices with probabilities, not generated text. Billed on input tokens only.">
      Decisions API — not an LLM
    </span>
  );
}
